import React from 'react';
import PropTypes from 'prop-types';
import sanitizeHTML from 'sanitize-html';
import ReactQuill, { Quill } from 'react-quill';

import { safeHTMLConfig } from '../SanitizedHTML';
import 'react-quill/dist/quill.snow.css';
import './styles.css';

const NORMAL_MODE = 'normal';
const EXTENDED_MODE = 'extended';
export const NORMAL_TOOLBAR = [
  ['bold', 'italic', 'underline', 'link'],
];
export const EXTENDED_TOOLBAR = {
  container: [
    ...NORMAL_TOOLBAR,
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

export function countChars(html) {
  return html && html.replace(/(<([^>]+)>)/ig, '').length;
}

class WYSIWYG extends React.PureComponent {
  static propTypes = {
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string,
    mode: PropTypes.oneOf([NORMAL_MODE, EXTENDED_MODE]),
    limit: PropTypes.number,
  };

  static defaultProps = {
    limit: 0,
    value: '',
    mode: EXTENDED_MODE,
  }

  static formats = [
    'bold',
    'italic',
    'underline',
    'link',
    'list',
    'bullet',
  ];

  html = this.props.value;

  state = {
    count: this.props.value ? countChars(this.props.value) : 0,
  };

  componentDidMount = () => {
    const Link = Quill.import('formats/link');
    Link.sanitize = this.setHttpsProtocol;
  }

  setHttpsProtocol = (url) => {
    if (url.toLowerCase().startsWith('https://') || url.toLowerCase().startsWith('http://')) {
      return url;
    }
    return `https://${url}`;
  };

  exceedsLimit = () => this.props.limit > 0 && countChars(this.html) > (this.props.limit);

  handleChange = (html, delta, source, editor) => {
    const { onChange } = this.props;
    this.html = sanitizeHTML(html, safeHTMLConfig);
    onChange(this.html, !this.exceedsLimit());
    this.setState({ count: countChars(this.html) });
  }

  render() {
    const { limit, value, mode, ...rest } = this.props;
    const { count } = this.state;

    return (
      <div styleName="wysiwyg-wrapper">
        <ReactQuill
          {...rest}
          defaultValue={value}
          onChange={this.handleChange}
          placeholder={this.props.placeholder}
          modules={{
            toolbar: mode === NORMAL_MODE ? NORMAL_TOOLBAR : EXTENDED_TOOLBAR,
            clipboard: {
              matchVisual: false,
            },
          }}
          formats={WYSIWYG.formats}
          theme="snow"
        />
        {limit > 0 && (
          <span id="char-counter" styleName={this.exceedsLimit() ? 'counter error' : 'counter'}>
            {count}/{limit} Characters
          </span>
        )}
      </div>
    );
  }
}

export default WYSIWYG;
